import type { Requirement } from "../types/compliance";
import { Badge } from "../components/ui";

export function RequirementBadges({
  requirement,
}: {
  requirement: Requirement;
}) {
  const required = requirement.fgrequire === 1;
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Badge
        variant="outline"
        className={`rounded-full ${
          required
            ? "border-slate-400 bg-white text-slate-700"
            : "border-dashed border-slate-300 bg-slate-100 text-slate-500"
        }`}
      >
        {required ? "Obrigatório" : "Complementar"}
      </Badge>
      <Badge
        variant="outline"
        className="rounded-full border-slate-200 bg-slate-100 text-slate-500"
      >
        {requirement.fgqtfile === 1 ? "Único" : "Múltiplos"}
      </Badge>
      {requirement.fgvalidcontrol === 1 && (
        <Badge
          variant="outline"
          className="rounded-full border-slate-200 bg-slate-100 text-slate-500"
        >
          Validade
        </Badge>
      )}
    </div>
  );
}
